<template>
  <div class="h5-page-eianFAQ">
    <p @click="openFile">名称：{{ name }}</p>
    <div align="center">
      <button @click="openFile">查看文件</button>
    </div>
  </div>
</template>

<script>
import api from '../../api/index'
export default {
  data () {
    return {
      name: ''
    }
  },
  mounted () {
    api.fileUploadEnquiry({
      secretKey: this.$route.query.secretKey
    }).then(res => {
      if (res.code === 200) {
        // window.open(res.data.url)
        this.name = res.data.name
      }
    })
  },
  methods: {
    openFile () {
      api.fileUploadEnquiry({
        secretKey: this.$route.query.secretKey
      }).then(res => {
        if (res.code === 200) {
          window.open(res.data.url)
          this.name = res.data.name
        }
      })
    }
  }
}
</script>

<style lang="scss">
.h5-page-eianFAQ {
  background: #f5f6f7;
  max-width: 680px;
  margin: 0 auto;
  .main-title {
    width: 100%;
    padding: 20px 0 20px;
    text-align: center;
  }
  .sth-top {
    border-top: 4px solid #fff;
  }
  .faq-div {
    width: calc(100% - 2 * 20px);
    padding: 10px 20px;
    border-top: 4px solid #fff ;
    h2, h3 {
      margin: 16px 0 4px;
    }
    p {
      line-height: 1.5em;
      text-indent: 2em;
      // padding: 0 1em;
    }
  }
}
</style>
